export default class Loot extends Phaser.GameObjects.Sprite {
    public body: Phaser.Physics.Arcade.Body;
    private _speed: number;
    private _boundaryBottom: number; // bottom boundary
    public attractionFlag: boolean = false;
    private _offsetX: number;
    private _offsetY: number;
    public tag: string;
    constructor(scene: Phaser.Scene, x: number, y: number, key: string, frame?: string) {
        super(scene, x, y, key, frame);
        this.tag = frame;
        scene.add.existing(this);
        this._boundaryBottom = window.constants.BASE_HEIGHT + this.height;
        this.setOrigin(0.5, 0.5);
        this._offsetX = Math.floor(window.constants["BASE_WIDTH"] * 0.3);
        this._offsetY = Math.floor(window.constants["BASE_HEIGHT"] * 0.4);
    }

    private _initPhysics(): void {
        this.scene.physics.world.enable(this);
        this.body.setGravity(0, this._speed);
        this.body.setAllowDrag(false);
        this.body.setAllowRotation(false);
        this.body.setSize(this.width, this.height);
        // this.body.setCollideWorldBounds(true);
    }    

    private _moveOffScreen() {
        this.x = window.constants.BASE_WIDTH + 100;
        this.y = window.constants.BASE_HEIGHT + 600;
    }

    public setProperties(speed: number) {
        this._speed = speed;
        this._initPhysics();
        this.stop();
    }

    
    private _checklBoundary()
    {
        if (this.y > this._boundaryBottom) {
            return true;
        }
        return false;
    }

    private _startPhysics(x, y) {
        this.scene.physics.world.enable(this);
        this.body.setEnable(true);
        this.body.reset(x, y);
        this.body.setVelocity( (x > window.constants["BASE_WIDTH"]/2)?-this._offsetX:this._offsetX, -this._offsetY);
    }

    private _stopPhysics() {
        this.body.stop();
        this.body.setEnable(false);
        this.scene.physics.world.disable(this);
    }
    
    public start(x, y)
    {
        this.setActive(true);
        this.setVisible(true);
        this._startPhysics(x, y);
        if(this.tag == "coin_flip_0"){
            this.play("coin_flip_anim");
        }
    }
    
    public stop() {
        this.setActive(false);
        this.setVisible(false);
        this._stopPhysics();
        this._moveOffScreen();
    }
    
    public hit(target) {
        let key = this.tag, value = 0;
        switch(this.tag)
        {
            case "health":
                value = 2;
                break;
            case "coin_flip_0":
                value = 1;
                break;
        }
        target.hit(key, value);
    }

    public moveTowardsTarget(target)
    {
        if(!this.attractionFlag)
        {
            this.scene.physics.moveToObject(this, target, this._speed);
        }
    }
    
    update(time, dt) {
        if (this.active) {
            if(this.y > this._boundaryBottom)
            {
                this.stop();
            }       
        }
    }
}